<template>
  <div>
          <!--====== APPIE PAGE TITLE PART START ======-->
    
    <div class="appie-page-title-area">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="appie-page-title-item">
                        <h3 class="title">Blog Grid</h3>
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><a href="#">Home</a></li>
                                <li class="breadcrumb-item active" aria-current="page">Blog Grid</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <!--====== APPIE PAGE TITLE PART ENDS ======-->
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>